module.exports = __webpack_public_path__ + "src/assets/games/8/87.jpg";